<template>
  <div class="footer">
    <div class="footer_info">
      <div class="footer_menu">
        <ul>
          <router-link :to=" { path:'/newsList' } ">
          <li>
            <span>新闻资讯</span>
            <img src="../../assets/images/arrow-left.png" alt="">
          </li>
          </router-link>
          <router-link :to=" { path:'/productList' } ">
          <li>
            <span>产品解决方案</span>
            <img src="../../assets/images/arrow-left.png" alt="">
          </li>
          </router-link>
          <router-link :to=" { path:'/cooperate' } ">
          <li>
            <span>合作伙伴</span>
            <img src="../../assets/images/arrow-left.png" alt="">
          </li>
          </router-link>
          <router-link :to=" { path:'/about' } ">
          <li>
            <span>关于博雅数字</span>
            <img src="../../assets/images/arrow-left.png" alt="">
          </li>
          </router-link>
        </ul>
      </div>
      <div class="footer_company">
        <p>地址：沈阳市浑南区全运五路35号（自贸区）沈阳国际设计谷2号楼3层</p>
        <p>电话：024-2296-5511</p>
        <p>邮编：110179</p>
        <p>邮箱：byop@byszdd.com</p>
      </div>
    </div>
    <div class="footer_bottom">
      <p>© 博雅数字(辽宁)经济发展有限公司</p>
      <p><span>辽ICP备20010852号-3</span> <span class="icp">辽公网安备21011202000641</span></p>
    </div>
  </div>
</template>
<script>
export default {
  
}
</script>
<style scoped>
.footer {
  background: #f9f9f9;
}  
.footer .footer_info {
  padding: 0 50px;
  box-sizing: border-box;
}
.footer .footer_info .footer_menu {
  font-size: 24px;
  color: #333;
  line-height: 80px;
}
.footer .footer_info .footer_menu ul li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ededed;
}

.footer .footer_info .footer_menu ul li img {
  display: block;
  width: 32px;
  height: 32px;
}
.footer .footer_info .footer_company {
  padding: 25px 0 30px 0;
  box-sizing: border-box;
}
.footer .footer_info .footer_company p {
  font-size: 24px;
  color: #666;
  line-height: 50px;
}

.footer .footer_bottom {
  padding: 30px 0;
  box-sizing: border-box;
  background: #ededed;
  text-align: center;
}
.footer .footer_bottom p {
  font-size: 24px;
  color: #666666;
  line-height: 40px;
}
.footer .footer_bottom .icp {
  margin-left: 10px;
}

</style>